<template>
  <div class="dialog-video-expired-pc" v-if="visible">
    <div class="dialog-video-expired-pc__body">
      <img
        class="subscribe-cover"
        src="../../../assets/img/playback_expire.png"
        alt="The video has expired"
      />
      <span>{{ $tec('512912') }}</span>
      <button class="btn-text" @click="iKnow">{{ $t('common.common_1033') }}</button>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'DialogVideoExpiredPc',
    data() {
      return {};
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      iKnow() {
        // 回放视频已过观看有效期
        if (this.$route.params.id) {
          this.$router.push({
            name: 'PageError',
            params: {
              id: this.$route.params.id,
              code: 512912
            }
          });
        }
        this.$emit('update:visible', false);
      }
    }
  };
</script>
<style lang="less">
  .dialog-video-expired-pc {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 35;
    .dialog-video-expired-pc__body {
      width: 400px;
      height: 260px;
      background: #ffffff;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 400;
      color: #262626;
      line-height: 20px;
      text-align: center;
      padding-top: 54px;
      box-sizing: border-box;
      margin: 20vh auto 0px auto;
      .subscribe-cover {
        width: 80px;
        height: 80px;
        margin-bottom: 10px;
        object-fit: contain;
      }
      span {
        display: block;
        text-align: center;
        margin-bottom: 18px;
        height: 20px;
        line-height: 20px;
      }
      .btn-text {
        width: 160px;
        height: 40px;
        background: var(--theme-color);
        border-radius: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #fff;
        line-height: 40px;
        border: none;
        outline: none;
      }
    }
  }
  @media screen and (max-width: 900px) {
    .dialog-video-expired-pc {
      width: 280px;
      height: 200px;
      padding-top: 20px;
    }
  }
</style>
